var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7384 0.16997C21.0376 0.414779 21.0817 0.855795 20.8369 1.15501L7.27434 17.7315C7.1491 17.8845 6.96496 17.9775 6.76744 17.9873C6.56991 17.9972 6.37744 17.923 6.23759 17.7832L0.209786 11.7554C-0.063581 11.482 -0.063581 11.0388 0.209786 10.7654C0.483153 10.4921 0.926369 10.4921 1.19974 10.7654L6.6806 16.2463L19.7534 0.268473C19.9982 -0.030738 20.4392 -0.0748396 20.7384 0.16997Z",
    fill: "#D1005D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.7dcb7452a46ea01b80873d336cedf1bf.svg";
export { ForwardRef as ReactComponent };